import React from 'react';
import styles from './styles.module.scss';
import icMaintenance from 'assets/svg/ic_maintenance.svg';
import ThetanButton from '@profile/src/Components/ThetanButton';
import Modal from '@profile/src/Components/Modal';

const MaintenanceModal = ({
  onClose
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icMaintenance
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Feature is under maintenance"), /*#__PURE__*/React.createElement("span", {
    className: styles.desc
  }, "Dear players, ", /*#__PURE__*/React.createElement("br", null), "Our system is under maintenance. This is to ensure better system performance and support further development. ", /*#__PURE__*/React.createElement("br", null), " We will endeavor to complete the maintenance work as quickly as possible, your patience is greatly appreciated!\xA0 ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Best Regards, Wolffun Team")), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(ThetanButton, {
    onClick: onClose,
    className: styles.btn,
    title: "OK"
  }))));
};

export default MaintenanceModal;